<template>
    <div>
        <MenuMember/>
        <CustomerList/>
    </div>
</template>

<script>
import MenuMember from '@/components/admin/member/menumember/MenuMember.vue'
import CustomerList from '@/components/admin/member/customer/CustomerList.vue'

export default {
    name:'customer',
    components:{
        MenuMember,
        CustomerList,
    }
}
</script>